/**
 * SearchNoResults Component
 *
 * Displayed when no search results are found.
 * Shows helpful message and optional suggestions.
 */

'use client';

import { productPaths } from '@/lib/paths';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { Link } from '@/lib/i18n/navigation';
import styles from './SearchNoResults.module.scss';

export interface SearchNoResultsProps {
  /** The search query that returned no results */
  query: string;
  /** Additional class name */
  className?: string;
}

export function SearchNoResults({ query, className }: SearchNoResultsProps) {
  const t = useTranslations('search.noResults');

  return (
    <div className={clsx(styles.container, className)} data-testid="search-no-results">
      <div className={styles.content}>
        <h2 className={styles.title}>{t('title')}</h2>

        {query && <p className={styles.query}>&ldquo;{query}&rdquo;</p>}

        <p className={styles.message}>{t('message')}</p>

        <div className={styles.actions}>
          <Link href={productPaths.watches()} className={styles.primaryAction}>
            {t('browseCollections')}
          </Link>
          <Link href="/contact" className={styles.secondaryAction}>
            {t('contactUs')}
          </Link>
        </div>
      </div>
    </div>
  );
}

SearchNoResults.displayName = 'SearchNoResults';
